import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";

export const PaymentCreateIntentApi = async (data) => {
  try {
    let response = await _axios.post(END_POINTS?.CREATE_INTENT, data);
    console.log("payment intent reponse==>", { response });

    return {
      success: true,
      data: response?.data,
    };
  } catch (e) {
    console.log("errror====>,e");
    return {
      success: false,
      error: e,
    };
  }
};

export const PaymentSimulateWebhookApi = (data) => {
  try {
    let response = _axios.post(END_POINTS?.WEBHOOK, data);
    console.log({ response });

    return {
      success: true,
      data: response,
    };
  } catch (e) {
    console.log("errror====>,e");
    return {
      success: false,
      error: e,
    };
  }
};
